import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCheckmark2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconCheckmark2"><Path fillRule="evenodd" clipRule="evenodd" d="M21.8337 2.93818C22.2821 3.2606 22.3843 3.88547 22.0618 4.33387L10.0177 21.0839C9.86179 21.3007 9.62557 21.4462 9.36172 21.4878C9.09788 21.5295 8.82834 21.4638 8.61319 21.3055L2.15731 16.5555C1.71246 16.2282 1.61717 15.6023 1.94447 15.1574C2.27178 14.7126 2.89773 14.6173 3.34258 14.9446L8.98414 19.0955L20.438 3.16628C20.7605 2.71788 21.3853 2.61575 21.8337 2.93818Z" fill="currentColor"/></CentralIconBase>;
});

export default IconCheckmark2;
